<script setup lang="ts">
import { useRouter } from "vue-router";
import { useNotifications } from "@/composables/useNotifications";

const { toasts, dismiss } = useNotifications();
const router = useRouter();

function open(id: number, href?: string) {
  dismiss(id);
  if (href) void router.push(href);
}
</script>

<template>
  <Teleport to="body">
    <TransitionGroup name="toast" tag="div" class="stack" aria-live="polite">
      <div v-for="t in toasts" :key="t.id" class="toast" :data-tone="t.tone" role="status">
        <span class="bar" />
        <button class="body" @click="open(t.id, t.href)">
          <strong>{{ t.title }}</strong>
          <span>{{ t.body }}</span>
        </button>
        <button class="x" aria-label="Dismiss" @click="dismiss(t.id)">×</button>
      </div>
    </TransitionGroup>
  </Teleport>
</template>

<style scoped>
.stack { position: fixed; right: 20px; bottom: 20px; z-index: 70; display: flex; flex-direction: column; gap: var(--space-3); width: min(380px, 90vw); }
.toast { display: flex; align-items: stretch; background: var(--bg-elev); border: 1px solid var(--line); border-radius: var(--radius-m); box-shadow: var(--shadow-2); overflow: hidden; }
.bar { width: 4px; background: var(--brand); }
.toast[data-tone="good"] .bar { background: var(--done); }
.toast[data-tone="bad"] .bar { background: var(--failed); }
.body { flex: 1; display: flex; flex-direction: column; gap: var(--space-1); padding: var(--space-4) var(--space-4); border: 0; background: transparent; text-align: left; font: inherit; cursor: pointer; }
.body strong { font-size: var(--text-sm); color: var(--ink); }
.body span { font-size: var(--text-sm); color: var(--muted); }
.x { border: 0; background: transparent; color: var(--faint); font-size: var(--text-md); padding: 0 var(--space-4); cursor: pointer; }
.x:hover { color: var(--ink); }
.toast-enter-active, .toast-leave-active { transition: all var(--speed-med) var(--ease-out); }
.toast-enter-from { opacity: 0; transform: translateY(12px) scale(.97); }
.toast-leave-to { opacity: 0; transform: translateX(24px); }
</style>
